"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_KINESIS_FIREHOSE_CONFIG = void 0;
exports.DEFAULT_KINESIS_FIREHOSE_CONFIG = {
    bufferSize: 1000,
    flushSize: 100,
    flushInterval: 5000,
    resendLimit: 5,
};
